import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { tokens } from '@hotjar/hotsauce';

const sizeMixin = ({ size }) =>
  size === 'sm'
    ? css`
        width: 15px;
        height: 15px;
        line-height: 15px;
        font-size: 9px;
      `
    : css`
        width: 19px;
        height: 19px;
        line-height: 19px;
        font-size: 12px;
      `;

export const QuestionNumberBadge = styled.span`
  display: inline-block;
  background: ${tokens.color.neutral_400};
  color: white;
  border-radius: 50%;
  text-align: center;
  font-weight: bold;

  ${sizeMixin}
`;
